export const SR_HITLIST_TASK_TYPE_FAILED_TOUR = 'failedTour';
export const SR_HITLIST_TASK_TYPE_PENDING_SECURITY_DEPOSIT = 'pendingSecurityDeposit';
export const SR_HITLIST_TASK_TYPE_PENDING_APP_COMPLETED = 'pendingAppCompleted';
export const SR_HITLIST_TASK_TYPE_PREQUAL_PENDING_APP = 'prequalPendingApp';
export const SR_HITLIST_TASK_TYPE_GOOD_TOUR_FEEDBACK_PENDING_APP = 'goodTourFeedbackPendingApp';
export const SR_HITLIST_TASK_TYPE_NO_TOUR_FEEDBACK_PENDING_APP = 'noTourFeedbackPendingApp';
export const SR_HITLIST_TASK_TYPE_TOUR_FEEDBACK_MISSING_INFO_PENDING_APP =
  'tourFeedbackMissingInfoPendingApp'; // eslint-disable-line max-len
export const SR_HITLIST_TASK_TYPE_LEAD_LISTING_NO_TOURS = 'leadListingNoTours';

export const SR_HITLIST_TASK_TYPE_LIST = [
  SR_HITLIST_TASK_TYPE_FAILED_TOUR,
  SR_HITLIST_TASK_TYPE_PENDING_SECURITY_DEPOSIT,
  SR_HITLIST_TASK_TYPE_PENDING_APP_COMPLETED,
  SR_HITLIST_TASK_TYPE_PREQUAL_PENDING_APP,
  SR_HITLIST_TASK_TYPE_GOOD_TOUR_FEEDBACK_PENDING_APP,
  SR_HITLIST_TASK_TYPE_NO_TOUR_FEEDBACK_PENDING_APP,
  SR_HITLIST_TASK_TYPE_TOUR_FEEDBACK_MISSING_INFO_PENDING_APP,
  SR_HITLIST_TASK_TYPE_LEAD_LISTING_NO_TOURS,
];

export const SR_HITLIST_TASK_TYPE_TO_LABEL_MAPPING = {
  [SR_HITLIST_TASK_TYPE_FAILED_TOUR]: 'Failed Tour',
  [SR_HITLIST_TASK_TYPE_PENDING_SECURITY_DEPOSIT]: 'Pending Security Deposit.',
  [SR_HITLIST_TASK_TYPE_PENDING_APP_COMPLETED]: 'Started App. Not Completed.',
  [SR_HITLIST_TASK_TYPE_PREQUAL_PENDING_APP]: "Prequal. Didn't Apply",
  [SR_HITLIST_TASK_TYPE_GOOD_TOUR_FEEDBACK_PENDING_APP]: '5-Star Feedback.',
  [SR_HITLIST_TASK_TYPE_NO_TOUR_FEEDBACK_PENDING_APP]: "No Tour Feedback. Didn't Apply",
  [SR_HITLIST_TASK_TYPE_TOUR_FEEDBACK_MISSING_INFO_PENDING_APP]:
    'Tour Feedback. Missing Info Pending App', // eslint-disable-line max-len
  [SR_HITLIST_TASK_TYPE_LEAD_LISTING_NO_TOURS]: 'Lead Not Toured',
};

export const SR_HITLIST_TASK_TYPE_TO_SECTION_MAPPING = {
  [SR_HITLIST_TASK_TYPE_FAILED_TOUR]: 'recent rental home tour',
  [SR_HITLIST_TASK_TYPE_PENDING_SECURITY_DEPOSIT]: 'rental app',
  [SR_HITLIST_TASK_TYPE_PENDING_APP_COMPLETED]: 'rental app',
  [SR_HITLIST_TASK_TYPE_PREQUAL_PENDING_APP]: 'rental app',
  [SR_HITLIST_TASK_TYPE_GOOD_TOUR_FEEDBACK_PENDING_APP]: 'recent rental home tour',
  [SR_HITLIST_TASK_TYPE_NO_TOUR_FEEDBACK_PENDING_APP]: 'recent rental home tour',
  [SR_HITLIST_TASK_TYPE_TOUR_FEEDBACK_MISSING_INFO_PENDING_APP]: 'rental app',
  [SR_HITLIST_TASK_TYPE_LEAD_LISTING_NO_TOURS]: 'recent rental home tour',
};

export const SR_HITLIST_TASK_CALL_OUTCOME_ANSWERED = 'answered';
export const SR_HITLIST_TASK_CALL_OUTCOME_NOT_ANSWERED = 'notAnswered';
export const SR_HITLIST_TASK_CALL_OUTCOME_NO_CALL_NEEDED = 'noCallNeeded';

export const SR_HITLIST_TYPE_CALL_OUTCOME_LIST = [
  SR_HITLIST_TASK_CALL_OUTCOME_ANSWERED,
  SR_HITLIST_TASK_CALL_OUTCOME_NOT_ANSWERED,
  SR_HITLIST_TASK_CALL_OUTCOME_NO_CALL_NEEDED,
];

export const SR_HITLIST_TYPE_HIGH_PRIORITY_LIST = [SR_HITLIST_TASK_TYPE_FAILED_TOUR];

export const SR_HITLIST_STATUS_CREATED = 'created';
export const SR_HITLIST_STATUS_STARTED = 'started';
export const SR_HITLIST_STATUS_COMPLETED = 'completed';
export const SR_HITLIST_STATUS_CANCELED = 'canceled';

export const SR_HITLIST_STATUS_LIST = [
  SR_HITLIST_STATUS_CREATED,
  SR_HITLIST_STATUS_STARTED,
  SR_HITLIST_STATUS_COMPLETED,
  SR_HITLIST_STATUS_CANCELED,
];
